import { getVaultMetadataByAddress } from '@/constants/nucleus-vaults';
import { getVaultByKey } from '@molecularlabs/nucleus-frontend';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { useAccount, useChainId } from 'wagmi';

export const useCurrentVault = () => {
  const { address } = useAccount();
  const chainId = useChainId();
  const { vaultAddress } = useParams() as { vaultAddress: EthAddress };
  const vaultMetadata = getVaultMetadataByAddress(vaultAddress);
  const { vaultKey } = vaultMetadata;
  const {
    data: vault,
    error: vaultError,
    status: vaultStatus,
  } = useQuery({
    queryKey: ['vault', vaultKey],
    queryFn: () => getVaultByKey(vaultKey),
  });

  return {
    address,
    chainId,
    ...vaultMetadata,
    vault,
    vaultError,
    vaultStatus,
    isLoadingVault: vaultStatus === 'pending',
  };
};
